import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { SharedFunctions } from '../shared.functions'; // our translate service
@Pipe({
    name: 'translate'
})
export class TranslatePipe implements PipeTransform {
    constructor(private sharedFunctionService: SharedFunctions) { }
    transform(value: string | null, args?: any[]): any {
        if (!value) return;
            return this.sharedFunctionService.getNombreMenuTenant(value);
    }
}